class EditableFieldDef {
  constructor(fieldObj) {
    for (const prop in fieldObj) {
      this[prop] = fieldObj[prop];
    }
  }

  // note: can be overridden
  validatePartial(value) {
    return true;
  }

  // note: can be overridden
  validateComplete(value) {
    return true;
  }

  // note: can be overridden
  formatValue(value) {
    if (!value) { 
      return ""; 
    }

    if (this.type === "select") {
      const option = this.options.find(o => o.key === value);
      return option ? option.value : value;
    }

    return value;
  }

  // note: can be overridden
  formatLabel() {
    return this.label ? this.label
      : this.fieldName ? this.fieldName.charAt(0).toUpperCase() + this.fieldName.slice(1)
      : "";
  }
}

export default EditableFieldDef;